<template>
  <v-app-bar
    app
    clipped-right clipped-left
    color="grey700" dark
    height="56"
  >
    <v-img
      src="@/assets/img/logo.png"
      max-width="180"
      class="mt-2 mr-5 logo-ctn flex-grow-0 align-self-start link"
      @click="$router.push({name: 'Home'}).catch(() => {})"
    />

    <!-- TODO move to component -->
    <div v-if="$vuetify.breakpoint.lgAndUp" class="menu-items d-none d-sm-flex ml-1">
      <v-menu
        bottom offset-y nudge-bottom="8" content-class="rounded-0"
        open-on-hover close-delay="100"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <MenuItem
              class="mr-7"
              :to="{name: 'Home'}"
              :icon="['fad', 'gamepad-alt']"
              title="Games"
            >
              <template #suffix>
                <fai class="suffix ml-1" :icon="['far', 'angle-down']" />
              </template>
            </MenuItem>
          </div>
        </template>

        <v-list color="grey500" class="py-0">
          <v-list-item
            v-for="(game, i) in games"
            :key="i"
            :ripple="false"
            class="game-item"
            color="primary500"
            :to="{ name: game.routeName }"
          >
            <!-- :class="$route.name === game.routeName && 'active'" -->
            <v-list-item-title class="d-flex align-center grey100--text py-3">
              <game-icon :game="game.id" class="mr-3 flex-grow-0" width="32" />
              <!-- <fai :icon="game.icon" fixed-width class="mr-3 primary400--text  text-h5 lh-1" /> -->
              <div>
                <h4 v-t="game.label" class="text-body-2 font-weight-semibold text-uppercase" />
                <h5 class="text-caption text--secondary lh-1-2">
                  <span v-if="game.count !== undefined">
                    <span v-if="game.routeName === 'Wheel'">{{ game.count }} players</span>
                    <span v-else-if="game.routeName === 'Cases'">{{ game.count }} opened</span>
                    <span v-else>{{ game.count }} games</span>
                    <span class="mx-1">&middot;</span>
                  </span>
                  <span v-if="game.total !== undefined">
                    <span v-if="game.routeName === 'Coinflip'">${{ game.total | toScrap }}</span>
                    <scrap v-else :amount="game.total" />
                  </span>
                </h5>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <MenuItem
        class="mr-4"
        :to="{name: 'Leaderboards'}"
        :icon="['fad', 'users-crown']"
        title="Top Bandits"
      />
    </div>

    <!-- mobile menu -->
    <v-menu
      v-else
      bottom offset-y nudge-bottom="8" content-class="rounded-0"
      open-on-hover close-delay="100"
    >
      <template #activator="{ on }">
        <div v-on="on">
          <MenuItem
            class="mobile-menu"
            :icon="['fas', 'bars']"
            title="Menu"
          />
        </div>
      </template>

      <v-list color="grey600" class="py-0">
        <v-list-item :ripple="false" :to="{name: 'Home'}" exact>
          Home
        </v-list-item>
        <v-list-item v-if="user" :ripple="false" @click="$modal.open('promo', { maxWidth: 400 })">
          <fai :icon="['fad', 'crown']" class="mr-2 green500--text" />
          Free scrap
        </v-list-item>
        <v-list-item v-if="user" :ripple="false" :to="{name: 'Deposit'}" exact>
          Deposit
        </v-list-item>
        <v-list-item :ripple="false" :to="{name: 'Leaderboards'}" exact>
          Top Bandits
        </v-list-item>
      </v-list>
    </v-menu>


    <v-spacer />

    <LocaleSwitcher
      class="mr-4 d-none d-md-block"
      icon-only :loading="loading.locale"
      @input="onLocaleChange"
    />

    <div v-if="user" class="user-container d-flex align-center">
      <v-btn
        color="green700 green200--text"
        class="rounded-0 mr-4 d-none d-md-block" min-width="100"
        depressed :ripple="false" small
        @click="$modal.open('promo', { maxWidth: 400 })"
      >
        <fai :icon="['fad', 'crown']" class="mr-2" />
        Free scrap
      </v-btn>

      <v-btn
        color="blue700 blue300--text"
        class="rounded-0 px-6 d-none d-md-block  mr-6"
        depressed :ripple="false" small
        :to="{name: 'Deposit'}"
      >
        <span class="text-body-2 mt-1 font-weight-bold" v-text="$t('cta.deposit')" />
      </v-btn>

      <Scrap class="text-subtitle-1 mr-6" :amount="user.balance" />

      <NotificationDrawer
        class="notifications"
        :notifications="notifications"
        @dismiss="onDismissNotification"
        @dismiss-all="onDismissAllNotifications"
      >
        <NotificationBell :count="notifications.length" />
      </NotificationDrawer>

      <NavbarUser :user="user" />
    </div>
    <LoginButton v-else @click="$modal.open('auth', { maxWidth: 320, persistent: true })" />
  </v-app-bar>
</template>

<script>
import NavbarUser from '@/components/layout/NavbarUser'
import LocaleSwitcher from '@/components/layout/LocaleSwitcher'
import MenuItem from '@/components/layout/MenuItem'
import NotificationBell from '@/components/NotificationBell'
import NotificationDrawer from '@/components/NotificationDrawer'

import Notification from '@/store/models/user/Notification'
import { mapGetters } from 'vuex'

export default {
  components: {
    NotificationBell,
    NotificationDrawer,
    NavbarUser,
    LocaleSwitcher,
    MenuItem,
  },
  data: () => ({
    loading: {
      locale: false,
    },
  }),
  computed: {
    ...mapGetters({
      conga: 'conga/conga',
      user: 'user/session',
      gamesSummaries: 'gamesSummaries',
    }),
    gamesConfig() {
      return this.conga.games
    },
    notifications() {
      return Notification.query()
        .where('unread', true)
        .orderBy('timestamp', 'desc')
        .get()
    },
    games() {
      const { gamesSummaries } = this

      const games = [
        {
          label: 'common.games.wheel',
          routeName: 'Wheel',
          id: 'wheel',
          count: gamesSummaries?.wheel?.players ?? 0,
          total: gamesSummaries?.wheel?.total ?? 0,
        },
        {
          label: 'common.games.caseBattles',
          routeName: 'Crate Battles',
          id: 'caseBattles',
          count: gamesSummaries?.caseBattles?.active ?? 0,
          total: gamesSummaries?.caseBattles?.won ?? 0,
        },
        {
          label: 'common.games.cases',
          routeName: 'Cases',
          id: 'cases',
          count: gamesSummaries?.cases?.opened ?? 0,
          total: gamesSummaries?.cases?.won ?? 0,
        },
        {
          label: 'common.games.coinflip',
          routeName: 'Coinflip',
          id: 'coinflip',
          count: gamesSummaries?.coinflip?.games ?? 0,
          total: gamesSummaries?.coinflip?.total ?? 0,
        },
        {
          label: 'common.games.dice',
          routeName: 'Beancan Blast',
          id: 'dice',
          total: gamesSummaries?.dice?.won ?? 0,
        },
        {
          label: 'common.games.spinners',
          routeName: 'Spinners',
          id: 'spinners',
          count: gamesSummaries?.spinners?.games ?? 0,
          total: gamesSummaries?.spinners?.total ?? 0,
        },

      ]

      const enabled = Object
        .entries(this.gamesConfig)
        .filter(([, i]) => !i.disabled)
        .map(([game]) => game)

      return games.filter(i => enabled.includes(i.id))
    },
  },

  methods: {
    onDismissAllNotifications() {
      Notification.delete(i => !i.persistent)
      // Notification.update({
      //   where: i => i.unread && !i.persistent,
      //   data: { unread: false },
      // })
    },
    onDismissNotification(id) {
      Notification.delete(id)
      // Notification.update({
      //   where: id,
      //   data: {
      //     unread: false,
      //   },
      // })
    },
    async onLocaleChange(locale) {
      if (this.loading.locale) return
      this.loading.locale = true

      try {
        await this.$i18n.loadAsyncLocale(locale)
        this.$toast.info(this.$t('notice.info.language_switched'))
      } catch (e) {
        this.$toast.error(this.$t('error.unexpected'))
        console.error(e)
      } finally {
        this.loading.locale = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.logo-ctn {
  @include xs {
    max-width: 90px !important;
  }

  @include sm {
    max-width: 100px !important;
  }

  @include md {
    max-width: 130px !important;
  }
}

.game-item {
  .active {
    color: primary() !important;
  }
}

.mobile-menu {
  @include xs {
    ::v-deep h4 {
      display: none;
    }
  }
}

.user-container {
  @include xs {
    .user-ctn {
      display: none !important;
    }

    .notifications {
      margin-right: 0;
    }
  }

  @include sm-up {
    .user-ctn {
      display: flex !important;

      ::v-deep .username {
        display: none !important;
      }
    }

    .notifications {
      margin-right: 24px;
    }
  }

  @include lg-up {
    .user-ctn {
      ::v-deep .username {
        display: flex !important;
      }
    }

    .notifications {
      margin-right: 24px;
    }
  }
}
</style>
